import React from 'react';

const EyeOff = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "21",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.82083 9.3225C8.50832 9.63513 8.3328 10.0591 8.33288 10.5011C8.33295 10.9432 8.50863 11.3671 8.82125 11.6796C9.13388 11.9921 9.55784 12.1676 9.99988 12.1675C10.4419 12.1675 10.8658 11.9918 11.1783 11.6792M13.9008 14.3942C12.7319 15.1255 11.3789 15.5091 10 15.5C7 15.5 4.5 13.8333 2.5 10.5C3.56 8.73333 4.76 7.435 6.1 6.605M8.48333 5.65C8.98253 5.54894 9.49068 5.49869 10 5.5C13 5.5 15.5 7.16667 17.5 10.5C16.945 11.425 16.3508 12.2225 15.7183 12.8917M2.5 3L17.5 18",
      stroke: "white",
      strokeOpacity: "0.6",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
EyeOff.displayName = "Icons.EyeOff";

export { EyeOff };
//# sourceMappingURL=EyeOff.js.map
